<template>
  <div v-if="showSemanticGraph && semanticgraph && semanticgraph.length > 0" class="mb-3">
    <b-card no-body v-for="(match,index) in semanticgraph" :key="'concept'+index" class="mb-2">
      <b-card-header header-bg-variant="transparent">
        {{$t('semanticgraph.info')}}: <b>{{match.name}}</b> // <b>{{match.id}}</b>
      </b-card-header>
      <b-list-group flush>
        <b-list-group-item v-for="(related,index) in match.related" :key="related.relationshipType + index" v-if="related.concepts && related.concepts.length > 0">
          <b>{{$t('semanticgraph.'+related.relationshipType)}}</b><br/>
          <b-badge variant="light" class="mr-1" v-for="concept in related.concepts">
          {{concept.name}}
          </b-badge>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'semanticgraph',
  data () {
    return {
      selected: null
    }
  },
  methods: {
    changeFilter: function (action) {
      this.$router.push(action);
    }
  },
  components: {
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    semanticgraph () {
      if (this.$store.state.response &&
          this.$store.state.response.semanticgraph &&
              this.$store.state.response.semanticgraph.matches) {
        return this.$store.state.response.semanticgraph.matches
      }
      return null;
    },
    showSemanticGraph () {
      return this.$store.state.showSemanticGraph;
    }
  }
}
</script>

<style scoped>
</style>
